import _styled, { default as _styled2, default as _styled3 } from "styled-components";
/* istanbul ignore file */
var _templateObject, _templateObject2;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import React from 'react';
import * as styles from "./FooterPromo.styles";
export var FooterPromo = function FooterPromo(_ref) {
  var children = _ref.children,
    intro = _ref.intro,
    title = _ref.title;
  return /*#__PURE__*/React.createElement(_StyledDiv, {
    $_css: styles.container
  }, /*#__PURE__*/React.createElement(_StyledH, {
    $_css2: styles.title
  }, title), /*#__PURE__*/React.createElement(_StyledP, {
    $_css3: styles.intro
  }, intro), children);
};
var _StyledDiv = _styled("div")(_templateObject || (_templateObject = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css;
});
var _StyledH = _styled2("h3")(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css2;
});
var _StyledP = /*#__PURE__*/_styled3("p").withConfig({
  displayName: "FooterPromo___StyledP",
  componentId: "sc-13z2kdq-0"
})(["", ""], function (p) {
  return p.$_css3;
});